import api from "../../../services/instanceapi";
import {getBoardMembers} from "../../../services/api";
import {FETCH_BOARD_MEMBERS, FETCH_BOARD_MEMBERS_FAIL} from "./actionTypes";
import {checkErrorMessage} from "../../../utils/utils";

export const loadBoardMembers = () => async (dispatch) => {
    try {
        const boardMembers = await api.get(getBoardMembers())
        const data = boardMembers.data
        dispatch({
            type: FETCH_BOARD_MEMBERS,
            payload: {
                boardMembers: data,
                status: boardMembers.status,
                message: boardMembers.statusText
            }

        })
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e?.response?.status

        if (status !== 200) {
            dispatch({
                type: FETCH_BOARD_MEMBERS_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            })
        }
    }
}